import React,{useRef,useState} from "react";
import Banner from "./Banner/Banner";
import CardsStatusSection from "./CardsStatusSection/CardsStatusSection";
import Offer from "./Offer/Offer";
import CheckOut from "./CheckOut/CheckOut";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import { common, publicNav } from "../../utils/navItems";
import Faq from "../../GlobalComponents/Faq/Faq";
import Footer from "../../GlobalComponents/Footer/Footer";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";

const Home = () => {
  const [address, setAddress] = useState("");
  const connectwalletRef = useRef(null);
  return (
    <div>
      <NavLayout setAddress={setAddress} bold={true} navItems={publicNav} parentRef={connectwalletRef}></NavLayout>
      <Banner parentRef={connectwalletRef}></Banner>
      <CardsStatusSection></CardsStatusSection>
      <CheckOut></CheckOut>
      <Offer></Offer>
      <div className="mt-[50px] md:mt-[100px]">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default Home;
